(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); }
    reveal(){ if (this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset(){ if (this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
  }
  customElements.define('sticky-header', StickyHeader);

  (function(){
    if (window.__bwCartLabelFixInit) return;
    window.__bwCartLabelFixInit = true;

    const ensure = () => {
      ['#cart-icon-bubble', '#cart-icon-bubble-mobile'].forEach((sel) => {
        const el = document.querySelector(sel);
        if (!el) return;

        let label = el.querySelector('.bw-icon-label');
        if (!label) {
          label = document.createElement('span');
          label.className = 'bw-icon-label';
          const bubble = el.querySelector('.cart-count-bubble');
          if (bubble) el.insertBefore(label, bubble);
          else el.appendChild(label);
        }

        label.textContent = 'Beutel';
        label.style.display = 'block';
      });
    };

    ensure();
    document.addEventListener('DOMContentLoaded', ensure);
    document.addEventListener('shopify:section:load', ensure);

    let raf = null;
    const mo = new MutationObserver(() => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(ensure);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    ['cart:refresh','cart:updated','cart:change','product:added','ajaxProduct:added'].forEach((evt) => {
      document.addEventListener(evt, ensure);
    });

    window.__bwEnsureCartLabel = ensure;
  })();

  function initBwTabs(root){
    const mq = window.matchMedia('(min-width: 990px)');
    if (!mq.matches) return;

    const tabs = Array.from(root.querySelectorAll('[data-bw-tab]'));
    if (!tabs.length) return;

    if (!window.__bwTabsDocBound){
      window.__bwTabsDocBound = true;
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-bw-tab]')) {
          document.querySelectorAll('[data-bw-tab][open]').forEach(t => t.removeAttribute('open'));
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') document.querySelectorAll('[data-bw-tab][open]').forEach(t => t.removeAttribute('open'));
      });
    }

    const closeAll = (except=null) => tabs.forEach(t => { if (t !== except) t.removeAttribute('open'); });

    tabs.forEach(t => {
      if (t.dataset.bwHoverInit === '1') return;
      t.dataset.bwHoverInit = '1';

      let timer;
      const open = () => {
        clearTimeout(timer);
        closeAll(t);
        t.setAttribute('open','open');
      };
      const closeLater = () => {
        clearTimeout(timer);
        timer = setTimeout(() => t.removeAttribute('open'), 160);
      };

      t.addEventListener('pointerenter', open);
      t.addEventListener('mouseenter', open);
      t.addEventListener('pointerleave', closeLater);
      t.addEventListener('mouseleave', closeLater);
    });
  }

  function bwUnlockMobileMenuScroll(){
    const classesToRemove = [
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'menu-opening'
    ];

    classesToRemove.forEach((className) => {
      document.documentElement.classList.remove(className);
      document.body.classList.remove(className);
      document.querySelectorAll('.menu-opening, .overflow-hidden, .overflow-hidden-mobile, .overflow-hidden-tablet').forEach((el) => {
        el.classList.remove(className);
      });
    });

    document.querySelectorAll('#Details-menu-drawer-container, .menu-drawer-container, #menu-drawer, .bw-menu-drawer').forEach((el) => {
      el.classList.remove('menu-opening', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
      el.style.removeProperty('overflow');
      el.style.removeProperty('overflow-y');
      el.style.removeProperty('position');
      el.style.removeProperty('height');
      el.style.removeProperty('top');
      el.style.removeProperty('left');
      el.style.removeProperty('right');
      el.style.removeProperty('width');
      el.style.removeProperty('touch-action');
      el.style.removeProperty('transform');
    });

    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow-y');
    document.documentElement.style.removeProperty('position');
    document.documentElement.style.removeProperty('height');
    document.documentElement.style.removeProperty('top');
    document.documentElement.style.removeProperty('width');
    document.documentElement.style.removeProperty('touch-action');

    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow-y');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('height');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('touch-action');
  }

  function bwFixWiderrufLinksAndMenuBackground(){
    document.querySelectorAll('.bw-mainitem').forEach((item) => {
      const text = (item.textContent || '').trim().toLowerCase();

      if (text.includes('bestellung widerrufen') || text.includes('bestellung widerufen')) {
        item.classList.add('bw-hide-main-widerruf');
      }
    });

    document.querySelectorAll('.bw-legal a').forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();

      if (text.includes('bestellung widerrufen') || text.includes('bestellung widerufen')) {
        link.setAttribute('data-bw-widerruf-link', 'true');
      }
    });

    const drawerShell = document.querySelector('#menu-drawer');
    const inner = document.querySelector('#menu-drawer .menu-drawer__inner-container');
    const drawer = document.querySelector('#menu-drawer .bw-drawer');
    const overlay = document.querySelector('.bw-drawer-overlay');

    if (drawerShell) {
      drawerShell.style.setProperty('background', '#fffaf2', 'important');
      drawerShell.style.setProperty('background-color', '#fffaf2', 'important');
      drawerShell.style.setProperty('background-image', 'none', 'important');
    }

    if (inner) {
      inner.style.setProperty('background', '#fffaf2', 'important');
      inner.style.setProperty('background-color', '#fffaf2', 'important');
      inner.style.setProperty('background-image', 'none', 'important');
    }

    if (drawer) {
      drawer.style.setProperty('background', '#fffaf2', 'important');
      drawer.style.setProperty('background-color', '#fffaf2', 'important');
      drawer.style.setProperty('background-image', 'none', 'important');
    }

    if (overlay) {
      overlay.style.setProperty('background', 'rgba(255, 250, 242, 0.96)', 'important');
      overlay.style.setProperty('background-color', 'rgba(255, 250, 242, 0.96)', 'important');
      overlay.style.setProperty('background-image', 'none', 'important');
    }
  }

  function initBwDrawer(root){
    const details = root.querySelector('#Details-menu-drawer-container');
    if (!details) return;

    const drawer = root.querySelector('[data-bw-drawer]');
    const overlay = root.querySelector('[data-bw-drawer-overlay]');
    const closeBtn = root.querySelector('[data-bw-drawer-close]');
    const mainList = root.querySelector('[data-bw-mainlist]');
    if (mainList && drawer){
      const count = mainList.querySelectorAll('.bw-mainitem').length || 7;
      drawer.style.setProperty('--bw-main-count', count);
    }

    const subData = root.querySelector('[data-bw-subdata]');
    const subList = root.querySelector('[data-bw-sublist]');
    const subTitle = root.querySelector('[data-bw-subtitle]');
    const backBtn = root.querySelector('[data-bw-back]');

    const close = () => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');

      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }

      if (drawer) {
        drawer.classList.remove('is-sub', 'menu-opening', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
      }

      if (subList) subList.innerHTML = '';

      bwUnlockMobileMenuScroll();
      requestAnimationFrame(bwUnlockMobileMenuScroll);
      setTimeout(bwUnlockMobileMenuScroll, 80);
      setTimeout(bwUnlockMobileMenuScroll, 220);
    };

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    root.querySelectorAll('[data-bw-open-sub]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        details.setAttribute('open', 'open');

        const id = btn.getAttribute('data-bw-open-sub');
        if (!id || !subData || !subList) return;

        const bucket = subData.querySelector(`[data-bw-sub="${id}"]`);
        if (!bucket) return;

        const title = bucket.getAttribute('data-title') || 'Menü';
        if (subTitle) subTitle.textContent = title;

        subList.innerHTML = '';
        bucket.querySelectorAll('a[data-label]').forEach((a) => {
          const href = a.getAttribute('href');
          const label = a.getAttribute('data-label');
          if (!href || !label) return;

          const li = document.createElement('li');
          li.className = 'bw-subitem';
          const link = document.createElement('a');
          link.className = 'bw-sublink';
          link.href = href;
          link.textContent = label;
          link.addEventListener('click', close);

          li.appendChild(link);
          subList.appendChild(li);
        });

        if (drawer) drawer.classList.add('is-sub');
      }, true);
    });

    if (backBtn) {
      const keepOpen = () => {
        requestAnimationFrame(() => details.setAttribute('open', 'open'));
        setTimeout(() => details.setAttribute('open', 'open'), 0);
      };
      const onBack = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        keepOpen();
        if (drawer) drawer.classList.remove('is-sub');
        if (subList) subList.innerHTML = '';
      };
      backBtn.addEventListener('pointerdown', onBack, true);
      backBtn.addEventListener('click', onBack, true);
    }

    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && details.hasAttribute('open')) close();
    });
  }

  function initBwCartFix(){
    if (window.__bwCartFixInit) return;
    window.__bwCartFixInit = true;
    let guardUntil = 0;

    document.addEventListener('pointerdown', (e) => {
      const hit =
        e.target.closest('cart-drawer .drawer__close') ||
        e.target.closest('cart-drawer .drawer__overlay') ||
        e.target.closest('#CartDrawer-Overlay') ||
        e.target.closest('cart-notification .cart-notification__close') ||
        e.target.closest('cart-notification .cart-notification__overlay');
      if (hit) guardUntil = Date.now() + 450;
    }, true);

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('#cart-icon-bubble, #cart-icon-bubble-mobile');
      if (!trigger) return;

      if (Date.now() < guardUntil) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        e.preventDefault();
        e.stopImmediatePropagation();
        cartDrawer.open(trigger);
      }
    }, true);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('#Details-menu-drawer-container summary, .header__icon--menu, [data-bw-drawer-close], [data-bw-drawer-overlay]')) {
      requestAnimationFrame(bwFixWiderrufLinksAndMenuBackground);
      setTimeout(bwFixWiderrufLinksAndMenuBackground, 40);
      setTimeout(bwFixWiderrufLinksAndMenuBackground, 120);
    }
  }, true);

  /* Mobile Drawer V13 listener */
  document.addEventListener('click', (event) => {
    if (event.target.closest('#Details-menu-drawer-container summary, .header__icon--menu')) {
      requestAnimationFrame(bwFixWiderrufLinksAndMenuBackground);
      setTimeout(bwFixWiderrufLinksAndMenuBackground, 60);
      setTimeout(bwFixWiderrufLinksAndMenuBackground, 180);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    bwUnlockMobileMenuScroll();

    document.addEventListener('click', (event) => {
      const closeHit = event.target.closest('[data-bw-drawer-close], [data-bw-drawer-overlay]');
      if (!closeHit) return;

      const details = document.querySelector('#Details-menu-drawer-container');
      if (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');

        const summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
      }

      bwUnlockMobileMenuScroll();
      requestAnimationFrame(bwUnlockMobileMenuScroll);
      setTimeout(bwUnlockMobileMenuScroll, 80);
      setTimeout(bwUnlockMobileMenuScroll, 220);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        bwUnlockMobileMenuScroll();
        setTimeout(bwUnlockMobileMenuScroll, 80);
      }
    }, true);

    bwFixWiderrufLinksAndMenuBackground();
    initBwTabs(document);
    initBwDrawer(document);
    initBwCartFix();
  });

  document.addEventListener('shopify:section:load', (e) => {
    bwUnlockMobileMenuScroll();
    bwFixWiderrufLinksAndMenuBackground();
    initBwTabs(e.target);
    initBwDrawer(e.target);
    initBwCartFix();
  });

  } catch(e) { console.error(e); }
})();
})();
